export function armGlobalDragCleanup(clean: () => void): () => void {
  const once = { once: true, capture: true } as AddEventListenerOptions;
  const off: Array<() => void> = [];

  const add = (name: string): void => {
    const handleClean = (): void => {
      clean();
    };
    window.addEventListener(name, handleClean, once);
    off.push(() => window.removeEventListener(name, handleClean, once));
  };

  add('mouseup');

  return (): void => {
    off.forEach((f) => f());
  };
}
